import styles from './styles.module.css';
import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';

import aboutImg from "src/assets/images/About.avif";
import { Link } from 'react-router-dom';
import { isRTL } from 'src/utils/global';



const About = () => {
    const { t } = useTranslation(['home']);
    return (
        <Element data-aos="fade-up" name="aboutUs" className={`${styles.about} ${isRTL() && styles.rtl}`}>
            <div className='container'>
                <div className={'row'}>
                    <div className='col-lg-5'>
                        <div className={styles.img__con}>
                            <img src={aboutImg}
                                alt={t("about.title.lg")}
                                width={460} height={240}
                                loading='lazy' />
                        </div>
                    </div>
                    <div className='col-lg-7 pe-md-4 my-auto'>
                        <div className={styles.subTitle}>
                            {t("about.title.sm")}
                        </div>
                        <h2 className={styles.title}>
                            {t("about.content.title")}
                        </h2>
                        <p className={styles.about__text}>
                            {t("about.content.text")}
                        </p>
                        <div className={styles.btn__con}>
                            <Link to='/about' className={`${styles.aboutBtn} bttn_primary`}>
                                {t('hero.btn')}
                            </Link>
                        </div>

                    </div>

                </div>
            </div>
        </Element>
    )
}

export default About;